import { defineStore, storeToRefs } from 'pinia'
import { Action } from './types'
import { computed } from 'vue'
import { usePrivileges } from './privileges'

export const allActions: Action[] = [
  { actionName: 'new-directory', labelKey: 'general__text__directory', icon: 'IconFolderSmall' },
  { actionName: 'new-link', labelKey: 'general__data__link', icon: 'IconLinkMedium' },
  { actionName: 'upload', labelKey: 'general__text__upload', icon: 'IconUpload' },
  {
    actionName: 'download',
    labelKey: 'general__text__download',
    icon: 'IconDownload',
    appliesOn: ['file']
  },
  {
    actionName: 'move',
    labelKey: 'general__text__move',
    icon: 'IconMoveFolder',
    appliesOn: ['file', 'directory', 'link']
  },
  // Not implemented yet
  // {
  //   actionName: 'archive',
  //   labelKey: 'general__text__archive',
  //   icon: 'IconArchive',
  //   appliesOn: ['file', 'directory', 'link']
  // },
  {
    actionName: 'delete',
    labelKey: 'general__text__delete',
    icon: 'IconTrash2Small',
    appliesOn: ['file', 'directory', 'link']
  },
  {
    actionName: 'open-directory',
    icon: 'IconFileSearch',
    labelKey: 'general__text__open-preview',
    appliesOn: ['directory']
  },
  {
    actionName: 'open-file',
    icon: 'IconFileSearch',
    labelKey: 'general__text__open-preview',
    appliesOn: ['file']
  },
  {
    actionName: 'open-link',
    icon: 'IconExternalLinkSmall',
    labelKey: 'general__data__open-link',
    appliesOn: ['link']
  },
  {
    actionName: 'change-connection',
    icon: 'IconMarkerPin',
    labelKey: 'general__text__change-connected-object',
    appliesOn: ['link', 'file']
  },
  {
    actionName: 'edit',
    icon: 'IconEditSmall',
    labelKey: 'general__text__change',
    appliesOn: ['directory', 'file', 'link']
  },
  {
    actionName: 'settings',
    labelKey: 'general__text__settings',
    icon: 'IconTool2'
  },
  {
    actionName: 'rename',
    labelKey: 'general__text__rename',
    icon: 'IconEditSmall',
    appliesOn: ['directory', 'file', 'link']
  }
]

export const useActions = defineStore('actions', () => {
  const { allowedActions } = storeToRefs(usePrivileges())
  const allActionsFiltered = computed(() =>
    allActions.filter((action) => allowedActions.value.includes(action.actionName))
  )

  const newActions = computed<Action[]>(
    () =>
      ['new-directory', 'new-link', 'upload']
        .map((actionName) =>
          allActionsFiltered.value.find((action) => action.actionName === actionName)
        )
        .filter(Boolean) as Action[]
  )

  const itemActions = computed<Action[]>(
    () =>
      ['download', 'move', 'archive', 'delete']
        .map((actionName) =>
          allActionsFiltered.value.find((action) => action.actionName === actionName)
        )
        .filter(Boolean) as Action[]
  )

  const listViewActions = computed(
    () =>
      [
        'open-file',
        'open-link',
        'change-connection',
        'edit',
        'download',
        'move',
        'archive',
        'delete'
      ]
        .map((actionName) =>
          allActionsFiltered.value.find((action) => action.actionName === actionName)
        )
        .filter(Boolean) as Action[]
  )

  return {
    newActions,
    itemActions,
    listViewActions
  }
})
